export default __webpack_public_path__ + "images/0282fb4a3bdc4219eddd49187acb2050-reporting_sp2_2@2x.png";